export class AntragsannahmeUrlParams {
  produktId: string; //GP, SB
  versicherungsnummer: number; //GP, SB
  processId: string; //SB
  smsDoi: boolean;
  emailDoi: boolean;
  bonitaet: boolean;
  compliance: boolean;
  antragsgenerationDatum: string;
  schwebeLfdNR: number;
  uiVorgangId: string;
  kollektivId: string;
}
